import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {Injectable} from '@angular/core';

export enum DateFormats {
  GermanDate = 1,
  IsoDate = 2
};

@Injectable()
export class NgbDateMomentParserFormatter extends NgbDateParserFormatter {

  /**
   * die Datums-Formate die zum parsen Benutzt werden können
   *
   * @var object
   */
  private formats = {
    1: 'D.M.YYYY',
    2: 'YYYY-MM-DD'
  };

  private currentFormat = this.formats[DateFormats.IsoDate];

  constructor(private formatType: number) {
    super();
    this.setFormat(formatType);
  }

  private setFormat(formatType: number) {
    if (!DateFormats[formatType]) {
      throw new Error('Invalid DateFormat supplied');
    }
    this.currentFormat = this.formats[formatType];
  }

  format(date: NgbDateStruct): string {
    const d = this.toDate(date);
    return d instanceof Date ? moment(d).format(this.currentFormat) : '';
  }

  toDate(date: NgbDateStruct): Date {
    if (date === null) {
      return null;
    }
    const d = moment({
      year: date.year,
      month: date.month - 1,
      date: date.day
    });

    return d.isValid() ? d.toDate() : null;
  }

  parse(value: string): NgbDateStruct {
    if (!value) {
      return null;
    }
    let d = moment(value, this.currentFormat);
    if (!d.isValid()) {
      d = moment(value);
    }
    return d.isValid() ? {
      year: d.year(),
      month: d.month() + 1,
      day: d.date()
    } : null;
  }
}
